import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=6e32adf1&scoped=true&"
import script from "./page-header.vue?vue&type=script&lang=js&"
export * from "./page-header.vue?vue&type=script&lang=js&"
import style0 from "./page-header.vue?vue&type=style&index=0&id=6e32adf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e32adf1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseBreadcrumbs: require('/opt/cargo.front/src/components/base/breadcrumbs.vue').default,RzContainer: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/components/container/index.js').default,RzIconDropArrow: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/icons/icon-drop-arrow/index.js').default})
